module.exports = __webpack_public_path__ + "static/img/Jade_Gresham_desktop.e328716.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jade_Gresham_desktop.jpg
// module id = qulI
// module chunks = 0